import { Injectable } from '@angular/core';
import { SavedQuoteConfigService, Cart, SavedQuoteTableComponent } from 'gung-standard';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { HeloSavedQuoteTableComponent } from '../components/helo-saved-quote-table/helo-saved-quote-table.component';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TyloSavedQuoteConfigService extends SavedQuoteConfigService {
  isHelo = environment.projectName === 'helo';

  getLayouts(): ListLayout<Cart>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => this.isHelo ? HeloSavedQuoteTableComponent : SavedQuoteTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'SavedQuoteGrid'
      }
    ];
  }
}
